import React,{Component} from 'react'
import { Marker,InfoWindow } from "react-google-maps"
import { MarkerClusterer } from "react-google-maps/lib/components/addons/MarkerClusterer"

class CostumMarker extends Component{
    constructor(){
        super();
        this.state={
            showMarkerText:false,
        }
    }
    
    onToogle=()=>{
        this.setState({
            showMarkerText: !this.state.showMarkerText
        })        
    }

    render(){
        const {marker,icons} = this.props 
    return(
            <Marker
                onClick={this.onToogle}
                key={marker.salesPointId}
                position={{ lat:parseFloat(marker.latitude), lng:parseFloat(marker.longtitude) }}
                icon={{url:icons}}
                animation={'google.maps.Animation.DROP'}
            >
            {this.state.showMarkerText &&
            <InfoWindow>
                <div className="InfoWindow">
                    <h5>{marker.address} - {marker.salesPointType}</h5>
                    <h4>{marker.salesPointName} </h4>
                </div>
            </InfoWindow>
            }
            </Marker>
        )
    }
}
export default CostumMarker;



// WEBPACK FOOTER //
// ./src/pages/SalePoints/CostumMarker.js